import api from '@/api_alv'
import { router } from '@/router.js'
import i18n from '@/assets/i18n/i18n'
import Vue from 'vue'

const DIR = 'az/live'

const DEFAULT_AZ_LIVE = {
    "id":               0,
    "alvId":            "ALV000000000AV", // AZ Venue
    "name":             null,
    "picture":          null,
    "addressRow1":      null,
    "addressRow2":      null,
    "zip":              null,
    "city":             null,
    "state":            null,
    "country":          null,
    "web":              null,
    "facebook":         null,
    "twitter":          null,
    "youtube":          null,
    "tags":             null,
    "shippingNote":     null,
    "shippingAddress":  null,
    "phone":            null,
    "fax":              null,
    "cellphone":        null,
    "email":            null,
    "notes":            null,
    "keyName":          null,
    "visibility":       2,
    // "rooms":           []
}

const DEFAULT_VENUE_ROOMS = {
    "id":           0,
    "name":         null,
    "area":         null,
    "capacity":     null
}

const state = {
    azLive:             [],
    azLiveSearch:       "",
    selectedAzLive:     [],
    expandedAzLive:     [],
    // Details
    defaultAzLive:      DEFAULT_AZ_LIVE,
    azLiveDetails:      {},
    // Venues
    // azLiveVenueRooms:                   [],
    // showAzLiveVenueRoomsEditingDialog:  false,
    // defaultAzLiveVenueRooms: DEFAULT_VENUE_ROOMS,
    // selectedAzLiveVenueRooms: [],
    // azLiveVenueRoomsEditingDialogDetails: DEFAULT_VENUE_ROOMS,

}

const getters = {
    getAzLive               (state) { return state.azLive },
    getAzLiveSearch         (state) { return state.azLiveSearch },
    getSelectedAzLive       (state) { return state.selectedAzLive },
    getExpandedAzLive       (state) { return state.expandedAzLive },

    // Details
    getDefaultAzLive                (state) { return state.defaultAzLive },
    getAzLiveDetails                (state) { return state.azLiveDetails },
    getAzLiveDetailsAlvId           (state) { return state.azLiveDetails.alvId },
    getAzLiveDetailsVenueName       (state) { return state.azLiveDetails.name },
    getAzLiveDetailsAddressRow1     (state) { return state.azLiveDetails.addressRow1 },
    getAzLiveDetailsAddressRow2     (state) { return state.azLiveDetails.addressRow2 },
    getAzLiveDetailsZip             (state) { return state.azLiveDetails.zip },
    getAzLiveDetailsCity            (state) { return state.azLiveDetails.city },
    getAzLiveDetailsState           (state) { return state.azLiveDetails.state },
    getAzLiveDetailsCountry         (state) { return state.azLiveDetails.country },
    getAzLiveDetailsWeb             (state) { return state.azLiveDetails.web },
    getAzLiveDetailsFacebook        (state) { return state.azLiveDetails.facebook },
    getAzLiveDetailsTwitter         (state) { return state.azLiveDetails.twitter },
    getAzLiveDetailsYoutube         (state) { return state.azLiveDetails.youtube },
    getAzLiveDetailsTags            (state) { return state.azLiveDetails.tags },
    getAzLiveDetailsShippingNote    (state) { return state.azLiveDetails.shippingNote },
    getAzLiveDetailsShippingAddress (state) { return state.azLiveDetails.shippingAddress },
    getAzLiveDetailsPhone           (state) { return state.azLiveDetails.phone },
    getAzLiveDetailsFax             (state) { return state.azLiveDetails.fax },
    getAzLiveDetailsCellphone       (state) { return state.azLiveDetails.cellphone },
    getAzLiveDetailsEmail           (state) { return state.azLiveDetails.email },
    getAzLiveDetailsNotes           (state) { return state.azLiveDetails.notes },
    getAzLiveDetailsKeyName         (state) { return state.azLiveDetails.keyName },
    getAzLiveDetailsVisibility      (state) { return state.azLiveDetails.visibility },
    // Venues
    // getAzLiveVenueRooms                     (state) { return state.azLiveVenueRooms },
    // getDefaultAzLiveVenueRooms              (state) { return state.defaultAzLiveVenueRooms },
    // getSelectedAzLiveVenueRooms             (state) { return state.selectedAzLiveVenueRooms },
    // getAzLiveVenueRoomsEditingDialogDetails (state) { return state.azLiveVenueRoomsEditingDialogDetails },
    // getAzLiveVenueRoomsDetailsName          (state) { return state.azLiveVenueRoomsEditingDialogDetails.name },
    // getAzLiveVenueRoomsDetailsArea          (state) { return state.azLiveVenueRoomsEditingDialogDetails.area },
    // getAzLiveVenueRoomsDetailsCapacity      (state) { return state.azLiveVenueRoomsEditingDialogDetails.capacity },
}

const mutations = {
    setAzLive:         (state, items)      => { state.azLive = items },
    setAzLiveSearch:   (state, search)     => { state.azLiveSearch = search },
    setSelectedAzLive: (state, selected)   => { state.selectedAzLive = selected },
    setExpandedAzLive: (state, expanded)   => { state.expandedAzLive = [expanded] },

    // Details
    setDefaultAzLive:               (state)             => { state.defaultAzLive = DEFAULT_AZ_LIVE },
    setAzLiveDetails:               (state, details)    => { state.azLiveDetails = details },
    setAzLiveDetailsAlvId:          (state, alvId)      => { state.azLiveDetails.alvId = alvId },
    setAzLiveDetailsVenueName:      (state, name)       => { state.azLiveDetails.name = name },
    setAzLiveDetailsAddressRow1:    (state, adress)     => { state.azLiveDetails.addressRow1 = adress },
    setAzLiveDetailsAddressRow2:    (state, adress)     => { state.azLiveDetails.addressRow2 = adress },
    setAzLiveDetailsZip:            (state, zip)        => { state.azLiveDetails.zip = zip },
    setAzLiveDetailsCity:           (state, city)       => { state.azLiveDetails.city = city },
    setAzLiveDetailsState:          (state, value)      => { state.azLiveDetails.state = value },
    setAzLiveDetailsCountry:        (state, country)    => { state.azLiveDetails.country = country },
    setAzLiveDetailsWeb:            (state, web)        => { state.azLiveDetails.web = web },
    setAzLiveDetailsFacebook:       (state, facebook)   => { state.azLiveDetails.facebook = facebook },
    setAzLiveDetailsTwitter:        (state, twitter)    => { state.azLiveDetails.twitter = twitter },
    setAzLiveDetailsYoutube:        (state, youtube)    => { state.azLiveDetails.youtube = youtube },
    setAzLiveDetailsTags:           (state, tags)       => { state.azLiveDetails.tags = tags },
    setAzLiveDetailsShippingNote:   (state, note)       => { state.azLiveDetails.shippingNote = note },
    setAzLiveDetailsShippingAddress:(state, address)    => { state.azLiveDetails.shippingAddress = address },
    setAzLiveDetailsPhone:          (state, phone)      => { state.azLiveDetails.phone = phone },
    setAzLiveDetailsFax:            (state, fax)        => { state.azLiveDetails.fax = fax },
    setAzLiveDetailsCellphone:      (state, cellphone)  => { state.azLiveDetails.cellphone = cellphone },
    setAzLiveDetailsEmail:          (state, email)      => { state.azLiveDetails.email = email },
    setAzLiveDetailsNotes:          (state, notes)      => { state.azLiveDetails.notes = notes },
    setAzLiveDetailsKeyName:        (state, name)       => { state.azLiveDetails.keyName = name },
    // setAzLiveDetailsType:           (state, type)       => { state.azLiveDetails.type = type },
    setAzLiveDetailsVisibility:     (state, value)      => { state.azLiveDetails.visibility = value },
    // Venues
    // setAzLiveVenueRooms:                        (state, rooms)      => { state.azLiveVenueRooms = rooms },
    // setDefaultAzLiveVenueRooms:                 (state)             => { state.defaultAzLiveVenueRooms = DEFAULT_VENUE_ROOMS },
    // setSelectedAzLiveVenueRooms:                (state, selected)   => { state.selectedAzLiveVenueRooms = selected },
    // setAzLiveVenueRoomsEditingDialogDetails:    (state, details)    => { state.azLiveVenueRoomsEditingDialogDetails = details },
    // setAzLiveVenueRoomsDetailsName:             (state, name)       => { state.azLiveVenueRoomsEditingDialogDetails.name = name },
    // setAzLiveVenueRoomsDetailsArea:             (state, area)       => { state.azLiveVenueRoomsEditingDialogDetails.area = area },
    // setAzLiveVenueRoomsDetailsCapacity:         (state, capacity)   => { state.azLiveVenueRoomsEditingDialogDetails.capacity = capacity },
}

const actions = {
    async fetchAzLive( { commit, getters }) {
        commit('setIsLoading', true)

        // check for set filters
        let filterObj = {
            'search' : getters.getAzLiveSearch
        }

        // create string of filter params for api call
        let paramsString = this._vm.$alvPlugin.createApiUrlFilterString(filterObj)

        // Get list items from db
        let response = await api.getListData(DIR, getters.getCurrentPage, paramsString) 

        if(response === undefined || response.list.length === 0 || response.error === 1) { 
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            commit('setAzLive', [])
        } else {
            commit('setAzLive', response.list)
        }

        this._vm.$alvPlugin.storePagingInformations(response.filteredRecords, response.currentPage, response.totalRecords)
        commit('setIsLoading', false)
    },
    async fetchAzLiveDetails({ commit, getters, dispatch }, alvId) {
        let values

        if(alvId === 'new') {
            let defaultValues = JSON.parse(JSON.stringify(getters.getDefaultAzLive)) 
            values = defaultValues
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
        } else {
            let response = await api.getDetailsById(DIR, alvId)
            if(response === undefined || response.length === 0 || response.error === 1) {
                response = {}
                commit('setSnackbar', {
                    type: 'error',
                    msg: 'Daten konnten nicht oder nur unvollständig geladen werden'
                })
            } else values = response
        }
        if(router.currentRoute.name == 'AzLiveList') {
            if(values.shippingNote !== null) values.shippingNote = values.shippingNote.replaceAll("\n", "<br />")
            if(values.shippingAddress !== null) values.shippingAddress = values.shippingAddress.replace(/\n/gi, "<br />")
            if(values.notes !== null) values.notes = values.notes.replace(/\n/gi, "<br />")
        } else {
            if(values.shippingNote !== null) values.shippingNote = values.shippingNote.replaceAll("<br />", "\n")
            if(values.shippingAddress !== null) values.shippingAddress = values.shippingAddress.replace(/<br\s*[\/]?>/gi, "\n")
            if(values.notes !== null) values.notes = values.notes.replace(/<br\s*[\/]?>/gi, "\n")
        }

        commit('setAzLiveDetails', values)
        // dispatch('fetchAzLiveVenueRooms')
        commit('setIsLoading', false)
    },
    // async fetchAzLiveVenueRooms({ commit, getters }) {
    //     let venueRoomsFromDb = getters.getAzLiveDetails.rooms

    //     if(venueRoomsFromDb === undefined || venueRoomsFromDb === null) commit('setAzLiveVenueRooms', [])
    //     else {
    //         if(venueRoomsFromDb.length === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND') 
    //         commit('setAzLiveVenueRooms', venueRoomsFromDb)
    //     }
    // },
    // async deleteSelectedAzLiveVenueRooms({ getters, commit }) {
    //     let selectedRoomId = getters.getSelectedAzLiveVenueRooms
    //     let allRooms = getters.getAzLiveVenueRooms
    //     let indexOfSelectedEntry = allRooms.findIndex(room => room.id === selectedRoomId) 

    //     let startAmount = allRooms.length
    //     Vue.delete(allRooms, indexOfSelectedEntry)
    //     let newAmount = allRooms.length
        
    //     if(startAmount > newAmount) {
    //         commit('setSnackbar', { 
    //             type: 'success', 
    //             msg: i18n.t('lang_PUBLISHING_WORKS_SNACKBAR_DELETE_OTHER_TITLE_SUCCESSFUL') + '<br />' + i18n.t('lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON'),
    //             timeout: -1
    //         })
    //     } else {
    //         commit('setSnackbar', { 
    //             type: 'error', 
    //             msg: i18n.t('lang_PUBLISHING_WORKS_SNACKBAR_DELETE_OTHER_TITLE_NOT_SUCCESSFUL'),
    //         })
    //     }

    //     commit('setSelectedAzLiveVenueRooms', [])
    //     if(newAmount === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
    // },
    async saveAzLiveForm({ commit, getters, dispatch }, redirect = true) { // redirect attribute is used when the saving function is called from another page than AzLiveEdit
        let alvId = getters.getAzLiveDetailsAlvId

        // getters.getAzLiveDetails.rooms = getters.getAzLiveVenueRooms
        let metaData = getters.getAzLiveDetails
        let isNew = false

        if(!redirect) { isNew = getters.getAzLiveDetails['id'] === 0 }
        else isNew = router.currentRoute.params.alvId === "new"

        let response = await api.saveEditForm(DIR, alvId, metaData, isNew)

        if(response === undefined || response.length === 0 || response.error === 1) { 
            let message = ''
            if(response.response.errorMsg !== undefined) {
                response.response.errorMsg.forEach(error => {
                    message += error + "<br />"
                })
            }
            else message = i18n.t('lang_GENERAL_CAPTION_ERROR')
            commit('setSnackbar', { 
                type: 'error', 
                msg: message,
            })
        } else {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_AZ_LIVE_SNACKBAR_VENUE_SAVED')
            })
            
            // redirect for url now with ALVID
            if(isNew && redirect) router.push( { name: 'AzLiveEdit', params: { alvId:  response.response.alvId } })

            // refresh data
            if(redirect) await dispatch('fetchAzLiveDetails',  response.response.alvId)
        }
    }
}

export default {
    state, getters, actions, mutations
}